import { filter } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Button,
    Card,
    Container,
    IconButton,
    MenuItem,
    Popover,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
// sections
// mock
import { ButtonGroup } from 'react-bootstrap';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import AddButton from 'src/components/Button.js/AddBotton';
import EmtyData from 'src/components/emty-data';
import Loader from 'src/components/loader/loader';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import DepartmentModal from 'src/components/modal/DepartmentModal';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import DepartmentListToolbar from 'src/sections/@dashboard/department/DepartmentListToolbar';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}

export default function Department() {
    const params = useParams();
    const [open, setOpen] = useState(null);
    const [visibleDel, setVisibleDel] = useState(false);
    const arrFillters = useRef([]);
    const { t } = useTranslation();
    const [getFlags, setGetFlags] = useState(false);
    const isEdit = useRef(false);
    const [tableData, setTableData] = useState([]);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);

    const [dataAction, setDataAction] = useState({});
    const [order, setOrder] = useState('asc');

    const [visible, setVisible] = useState(false);

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [department, setDepartment] = useState({});

    const getRef = useRef(false);
    const tableRef = useRef(null);
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('quan_ly_bo_phan'),
        sheet: t('quan_ly_bo_phan'),
    });

    const TABLE_HEAD = [
        { id: 'name', label: t('name_department'), alignRight: false },
        { id: 'company', label: t('code_department'), alignRight: false },
        { id: 'role', label: t('group_staff'), alignRight: false },
        { id: 'Thao tác', label: '', alignRight: false },
    ];

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 600);
    }, []);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [+params.idPermission];
        sendRequest(serviceList.getAlldepartment, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log("department", message.proc_data.rows[0].o_2[0][0])
            setTableData(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
            setDepartment(message.proc_data.rows[0].o_2[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = tableData.map((n) => n.supplier_nm);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleDelete = () => {
        if (!dataAction.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [dataAction.id];
        sendRequest(serviceList.deletedepartment, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const fillterSearcher = (value) => {
        if (value === '' || !value) {
            return setTableData(arrFillters.current);
        }
        const arrSearch = arrFillters.current.filter(
            (data) => data.departs_nm.includes(value.toUpperCase()) || data.depart_cd.includes(value.toUpperCase())
        );
        setTableData(arrSearch);
    };

    return (
        <>
            <Helmet>
                <title> {t('quan_ly_bo_phan')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('quan_ly_bo_phan')}
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<Iconify icon="mingcute:file-export-line" />}
                        onClick={onDownload}
                    >
                        {t('export_excel')}
                    </Button>
                </Stack>{' '}
                <Breadcrumb paths={[{ label: t('quan_ly_bo_phan'), url: '#', navigate: false }]} />
                <Loader loading={getFlags} />
                <DepartmentModal
                    fuctGet={getData}
                    idPermission={params.idPermission}
                    setVisible={setVisible}
                    visible={visible}
                    isEdit={isEdit.current}
                    dataUpdate={dataAction}
                />
                <Card>
                    <DepartmentListToolbar numSelected={selected.length} getValue={fillterSearcher} />
                    <ConfirmModal visible={visibleDel} setVisible={setVisibleDel} handleDelete={handleDelete} />

                    <TableContainer sx={{}}>
                        <Table ref={tableRef}>
                            <DepartmentListHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                                numSelected={selected.length}
                                onRequestSort={handleRequestSort}
                                onSelectAllClick={handleSelectAllClick}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item) => {
                                        return (
                                            <TableRow
                                                hover
                                                key={item.id}
                                                tabIndex={-1}
                                                role="checkbox"
                                                // selected={selectedUser}
                                            >
                                                <TableCell padding="checkbox"></TableCell>

                                                <TableCell align="left">{item.departs_nm}</TableCell>
                                                <TableCell align="left">{item.depart_cd}</TableCell>

                                                <TableCell align="left">
                                                    {glb_sv.convertMultipleLanguages(item.group_nm)}
                                                </TableCell>

                                                <TableCell align="right" style={{ maxWidth: '120px' }}>
                                                    <ButtonGroup
                                                        variant="text"
                                                        aria-label="text button group"
                                                        style={{ display: 'flex', justifyContent: 'flex-start' }}
                                                    >
                                                        {' '}
                                                        {department?.delete_permission === '1' && (
                                                            <IconButton
                                                                size="large"
                                                                color={'warning'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    isEdit.current = true;
                                                                    setVisible(true);
                                                                }}
                                                            >
                                                                <Iconify icon={'eva:edit-fill'} />
                                                            </IconButton>
                                                        )}{' '}
                                                        {department?.update_permission === '1' && (
                                                            <IconButton
                                                                size="large"
                                                                color={'error'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    setVisibleDel(true);
                                                                }}
                                                            >
                                                                <Iconify icon={'eva:trash-2-outline'} />
                                                            </IconButton>
                                                        )}
                                                    </ButtonGroup>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>

                        {tableData.length === 0 && <EmtyData />}
                    </TableContainer>
                </Card>
            </Container>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 1,
                        width: 140,
                        '& .MuiMenuItem-root': {
                            px: 1,
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }}
            >
                <MenuItem>
                    <Iconify
                        icon={'eva:edit-fill'}
                        sx={{ mr: 2 }}
                        onClick={() => {
                            isEdit.current = true;
                            setVisible(true);
                        }}
                    />
                    Edit
                </MenuItem>

                <MenuItem sx={{ color: 'error.main' }}>
                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                    Delete
                </MenuItem>
            </Popover>
            {/* <ProductCartWidget /> */}
            {department?.insert_permission === '1' && (
                <AddButton
                    onClick={() => {
                        isEdit.current = false;
                        setVisible(true);
                        setDataAction({});
                    }}
                />
            )}
        </>
    );
}
